
import React from 'react';
import styled from 'styled-components';

const Button = styled.div`
  display: flex;
  height: 40px;
  width: ${ props => props.width };
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin:10px;
  color: white;
  background-color: var(--color-brand-pink-primary);
  border-radius: 5px;
  
  &:hover {
      background-color: var(--color-createenv-stepper-next-btn-bg-hover);
  }
`;

const SubmitButton = ({ label, onClick, width, disabled=true }) => {
    return (
        <Button
            className={ "submitButton" }
            onClick={ (event) => onClick(event, disabled) }
            width={ width }>
            { label }
        </Button>
    );
}

export default SubmitButton;